import { Tooltip } from "@nulogy/components";
import CommonIndicator from "components/common/CustomWorkOrderFieldIndicator";
import TruncatedTextTooltip from "components/pages/schedule/workOrderCards/TruncatedTextTooltip";
import isEmpty from "lodash/isEmpty";
import React from "react";

export default function CustomWorkOrderFieldIndicator({ description, highlight, indicator, userCanUpdate }) {
  if (isEmpty(description)) return null;
  if (!indicator || indicator === "blank") return null;

  const descriptionKabob = description.replace(/\s/g, "-").toLowerCase();

  return (
    <Tooltip
      data-testid="custom-work-order-field-tooltip"
      maxWidth="200px"
      showDelay="500"
      tooltip={<TruncatedTextTooltip label={description} />}
    >
      <CommonIndicator
        className={`spec-custom-work-order-field-indicator-${descriptionKabob}`}
        color={indicator}
        data-testid="custom-work-order-field-indicator"
        highlight={highlight}
        userCanUpdate={userCanUpdate}
      />
    </Tooltip>
  );
}
